import _ from 'lodash';
import { IPosition } from '../components/TableWithState/CellWithFilter/CellWithFilter';
import {
  createInitFilterState,
  IFilter,
  IFiltering,
  IListItem,
  ISelectedFilter,
  ITableFilters,
} from '../contexts/filter/FiltersProvider';

import { EPaths } from '../types/enums/EPaths';
import { ETables } from '../types/enums/ETables';

const ColumnsWithDateSearch: string[] = ['registrationDate', 'createdAt'];
const underscoredColumnKeysMap: Record<string, string> = ColumnsWithDateSearch.reduce(
  (acc, key) => ({ ...acc, [key]: '_' + key }),
  {},
);
export function columnKeysWithUnderscore(key: string) {
  return underscoredColumnKeysMap[key] || key;
}
export const shouldHasDateInput = (columnId: string) => {
  return !!ColumnsWithDateSearch.find((column) => column === columnId);
};

export const calcPosition = (cellRef: any): IPosition => {
  const FILTER_WIDTH = 340;

  const { left, height, width } = cellRef.current.getBoundingClientRect();

  let leftOffset: number = 0;

  const elemIsOutViewport = window.innerWidth < left + FILTER_WIDTH;

  if (elemIsOutViewport) leftOffset = 0 - FILTER_WIDTH + width + 16;

  return { left: leftOffset, top: height };
};

const BODY_LIST_ID = 'itemsList';

export const resetItemListScroll = () => {
  document.getElementById(BODY_LIST_ID)?.scroll(0, 0);
};

export const getCurrentState = (filters: ITableFilters, tableName: string, column: string): IFilter | null => {
  let filterState: IFilter | null = null;

  try {
    filterState = filters[tableName][column] as IFilter;
  } catch (e) {
    // filterState = createInitFilterState(column);
  }

  return filterState;
};

export function getCheckedItemsAsFiltering(items: IListItem[], filterName: string): IFiltering[] {
  return items.filter((item) => item.checked).map((item) => ({ key: filterName, value: item.label }));
}

export function getSelectedFiltersAsFiltering(selectedFilters: ISelectedFilter[]): IFiltering[] {
  const filtering: IFiltering[] = [];

  for (const filter of selectedFilters)
    filter.items.forEach((label) => filtering.push({ key: columnKeysWithUnderscore(filter.column), value: label }));

  return filtering;
}

export function getAllFilteringFromTable(filters: ITableFilters, tableName: string): IFiltering[] {
  const filtering: IFiltering[] = [];

  for (const filterName in filters[tableName]) {
    filtering.push(
      ...[
        ...getSelectedFiltersAsFiltering(filters[tableName][filterName].selectedFilters),
        ...getCheckedItemsAsFiltering(filters[tableName][filterName].items, filterName),
      ],
    );
  }

  return _.uniqBy(filtering, 'value');
}

const columnsWithoutFilters: string[] = ['delete', 'image', 'jsxCheckbox', 'action', 'insertedCount', 'usedCount'];

const tableColumnsWithoutFilters: Partial<Record<string, string[]>> = {
  [ETables.CruiseLines]: ['edited'],
};

const tableListPathByName: Partial<Record<string, string>> = {
  [ETables.CruiseShips]: EPaths.CruiseShips,
  [ETables.CruiseLines]: EPaths.CruiseLines,
};

export const isTableListPage = (pathname: string, tableName: string): boolean => {
  const listPath = tableListPathByName[tableName];
  if (listPath) {
    return pathname === listPath;
  }

  return pathname.length === tableName.length + 1;
};

export const shouldHasFilter = (columnId: string, tableName?: string): boolean => {
  if (columnsWithoutFilters.includes(columnId)) {
    return false;
  }

  if (tableName && tableColumnsWithoutFilters[tableName]?.includes(columnId)) {
    return false;
  }

  return true;
};
